import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { ThemeCustomizerService } from 'src/app/components/common/theme-customizer/theme-customizer.service';
import { PublicServiceService } from 'src/app/public-service.service';
import { getImgeUrl } from 'src/environments/environment';

@Component({
  selector: 'app-blog-details',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './blog-details.component.html',
  styleUrl: './blog-details.component.scss'
})
export class BlogDetailsComponent {

  isToggled = false;
  id
  blog
  imageURL = getImgeUrl()
  constructor(
    public themeService: ThemeCustomizerService, 
    private activeRouter: ActivatedRoute, 
    private publicService: PublicServiceService, 
  ) {
      this.themeService.isToggled$.subscribe(isToggled => {
          this.isToggled = isToggled;
      });
  }

  toggleTheme() {
      this.themeService.toggleTheme();
  }

  ngOnInit(): void {
    this.id = this.activeRouter.snapshot.params["id"]
    this.getData()
  }

  getData() {
    this.publicService.getRecordById(this.publicService.BLOGS_URL, this.id).subscribe({
      next: (res) => {
        this.blog = res
      },
      error: (err) => {
        console.log(err)
      }
    })
  }

}
